import _ from "lodash";

export const LowPass = function (x, y, smoothingMult) {
  this.x = x;
  this.y = y;
  var avgXDiff = (x[x.length - 1] - x[0]) / x.length;
  this.smoothing = smoothingMult * avgXDiff;
};

LowPass.prototype = {
  filter: function () {
    var value;
    var xpt, xprev, ypt, yprev;
    for (var i = 0, len = this.y.length; i < len; i++) {
      if (!_.isNumber(this.x[i]) || !_.isNumber(this.y[i])) continue;
      if (!_.isNumber(value)) value = this.y[i];
      xprev = xpt;
      yprev = ypt;
      xpt = this.x[i];
      ypt = this.y[i];
      if (!_.isNumber(xprev) || !_.isNumber(yprev)) continue;
      var xDiff = xpt - xprev;
      var adj = this.smoothing / xDiff;
      if (adj < 1) adj = 1;
      value += (ypt - value) / adj;
      this.y[i] = value;
    }
    return this.y;
  },
};

export const MovingAverage = function (x, y) {
  this.x = x;
  this.y = y;
  this.winWidth = 150;
  this.kernelWidth = 7;
};
MovingAverage.prototype = {
  filter: function () {
    // window size has to be even
    var z = (this.kernelWidth - 1) / 2; // used to calc indices
    var s = 0; // point start index
    var e = 0; // point end index
    var width = 0;
    var result = new Array(this.x.length);

    for (var i = 0; i < this.x.length; i++) {
      s = i - z;
      e = i + z;

      while (s < 0) {
        s += 1;
      }
      while (e >= this.y.length) {
        e -= 1;
      }

      if (this.winWidth > 0) {
        width = this.x[e] - this.x[s];
        while (width > this.winWidth) {
          if (s + 1 <= i && e - i <= i - s) {
            s += 1;
          }
          if (e - 1 >= i && e - 1 >= i - s) {
            e -= 1;
          }
          width = this.x[e] - this.x[s];
        }
      }
      // trace(e-s)

      var sum = 0;
      for (var j = s; j <= e; j += 1) {
        sum += this.y[j];
      }
      result[i] = sum / (e - s + 1);
    }
    return result;
  },
};

export const DJFilter = function (points, tau) {
  this.points = points;
  this.tau = tau || 30; // 30 seconds default
};

DJFilter.prototype = {
  filter: function () {
    var directions = [-1, 1];
    var yPrev, xPrev, ySmooth;

    for (var a = 0; a < directions.length; a++) {
      var direction = directions[a];

      for (var i = 0; i < this.points.length; i++) {
        var n = direction === 1 ? i : this.points.length - 1 - i;

        var x = this.points[n].x;
        var y = this.points[n].y;

        if (ySmooth == null || xPrev == null || yPrev == null) {
          ySmooth = y;
        } else {
          var u = Math.abs(x - xPrev) / this.tau;
          var z = Math.exp(-u);
          var dy = y - yPrev;

          if (u > 0) {
            ySmooth = ySmooth * z + y * (1 - z) + (dy / u) * ((u + 1) * z - 1);
          }
        }

        // trace([y, ySmooth])
        yPrev = y;
        xPrev = x;

        if (direction === -1) {
          this.points[n].ySmooth = ySmooth;
        } else {
          this.points[n].ySmooth = (this.points[n].ySmooth + ySmooth) / 2;
        }
      }
    }
    return _.map(this.points, function (pt) {
      return pt.ySmooth;
    });
  },
};

export const Filter = function () {};

Filter.prototype = {
  filter: function () {
    // window size has to be even
    var z = 0; // used to calc indices
    var s = 0; // point start index
    var e = 0; // point end index
    var ks = 0; // kernel start index
    var ke = 0; // kernel end index
    var width = 0;
    var usedKern;
    var neighbors;
    var result = new Array(this.x.length);
    var kernels = [];

    z = (this.kernel.length - 1) / 2;
    for (var i = 0; i < this.x.length; i++) {
      var val = 0; // used to push new value into returned array
      s = i - z;
      e = i + z;
      ks = 0;
      ke = this.kernel.length - 1;

      while (s < 0) {
        s += 1;
        ks += 1;
      }
      while (e >= this.x.length) {
        e -= 1;
        ke -= 1;
      }

      if (this.winWidth > 0) {
        width = this.x[e] - this.x[s];
        while (width > this.winWidth) {
          if (s + 1 <= i && e - i <= i - s) {
            s += 1;
            ks += 1;
          }
          if (e - 1 >= i && e - 1 >= i - s) {
            e -= 1;
            ke -= 1;
          }
          width = this.x[e] - this.x[s];
        }
      }

      // be somewhat efficient and cache reuseable kernels
      if (kernels[ke + 1 - ks]) {
        usedKern = kernels[ke + 1 - ks];
      } else {
        usedKern = this.normalizeKernel(this.kernel.slice(ks, ke + 1));
        kernels[ke + 1 - ks] = usedKern;
      }

      neighbors = new Array(e - s);
      var index = 0;
      for (var j = s; j <= e; j += 1) {
        // if (j >= 0 && j < this.y.length)
        neighbors[index] = this.y[j];
        index += 1;
      }

      for (j = 0; j < neighbors.length; j++) {
        val += neighbors[j] * usedKern[j];
      }
      result[i] = Math.round(val * 1000.0) / 1000.0;
    }
    return result;
  },

  createSincKernel: function (kernSize, freq) {
    if (kernSize === 1) return [1];
    var kern = new Array(kernSize);
    var x = 0;

    for (var i = 0; i <= kernSize; i++) {
      kern[i] = 0.54 - 0.46 * Math.cos((2 * Math.PI * i) / kernSize);
      x = i - kernSize / 2;
      if (x === 0) kern[i] = kern[i] * 2 * Math.PI * freq;
      else kern[i] = (kern[i] * Math.sin(2 * Math.PI * freq * x)) / x;
    }

    return kern;
  },

  createGaussianKernel: function (kernSize, sd) {
    if (kernSize === 1) return [1];
    var kern = new Array(kernSize);

    for (var i = 0; i <= kernSize; i++) {
      kern[i] = (1 / (Math.sqrt(2 * Math.PI) * sd)) * Math.exp(-0.5 * Math.pow(i / sd, 2));
    }
    return kern;
  },

  normalizeKernel: function (kern) {
    var i = 0;
    var norm = 0;
    var newkern = new Array(kern.length);

    for (i = 0; i < kern.length; i++) {
      norm += kern[i];
    }
    for (i = 0; i < kern.length; i++) {
      newkern[i] = kern[i] / norm;
    }
    return newkern;
  },
};

export const GaussianFilter = function (x, y, start, sd, winWidth) {
  var startn = start || 10;
  sd = sd || 8.0;
  var usedn = startn > x.length ? (x.length % 2 !== 0 ? x.length + 1 : x.length) : startn;

  this.x = x;
  this.y = y;
  this.winWidth = winWidth || 100;
  this.kernel = this.createGaussianKernel(usedn, sd);
};
GaussianFilter.prototype = new Filter();

export const SincFilter = function (x, y, startn, freq, winWidth) {
  startn = startn || 10;
  freq = freq || 0.04;
  var usedn = startn > x.length ? (x.length % 2 !== 0 ? x.length + 1 : x.length) : startn;

  this.x = x;
  this.y = y;
  this.winWidth = winWidth || 100;
  this.kernel = this.createSincKernel(usedn, freq);
};
SincFilter.prototype = new Filter();

export const SavitskyGolayFilter = function (x, y) {
  this.x = x;
  this.y = y;
  this.winWidth = 0; // 100
  this.kernel = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
  // this.kernel = this.createSGKernel()
};
SavitskyGolayFilter.prototype = new Filter();
